module.exports = __webpack_public_path__ + "assets/role-role.3311fb64.svg";